import { Badge } from '@/components/ui/badge'

export type TabCountBadgeProps = {
  count: number
}

/** Optional inline count on a line tab — render only when the parent passes it. */
export function TabCountBadge({ count }: TabCountBadgeProps) {
  if (count <= 0) return null
  return (
    <Badge
      variant="outline"
      className="ml-0.5 border-border bg-accent px-1.5 py-0 text-[10px] tabular-nums text-accent-foreground"
    >
      {count}
    </Badge>
  )
}
